import { Injectable, inject } from '@angular/core';
import { AiEntitlementState } from '../../states/ai-entitlement.state';
import { GetAiEntitlementStateResult } from './get-ai-entitlement-state.result';

/**
 * Get AI Entitlement State Use Case.
 *
 * Provides read-only access to AI entitlement state signals. Use this in the
 * presentation layer instead of injecting AiEntitlementState directly. To
 * hydrate the state, use LoadAiEntitlementUseCase.
 */
@Injectable({ providedIn: 'root' })
export class GetAiEntitlementStateUseCase {
  private readonly _state = inject(AiEntitlementState);

  /**
   * Execute the use case.
   * @returns Read-only access to AI entitlement state signals.
   */
  public execute(): GetAiEntitlementStateResult {
    return {
      aiEntitlementEnabled: this._state.aiEntitlementEnabled,
    };
  }
}
